import instance from '../index'

//首页轮播图
export  function getBanner(){
 return instance({
    method: 'post',
    url: 'banner?type=1',
  })
}

//推荐歌单
export  function getMusciList(){
  return instance({
     method: 'post',
     url: '/personalized?limit=10',
   })
 }
 
 //搜索
 export  function getSearchMusic(data){
  return instance({
     method: 'get',
     url: `/search?keywords= ${data}`,
   })
 }
 //手机号登录/login/cellphone?phone=xxx&password=yyy
 export  function getLoginInfo(data){
  return instance({
     method: 'get',
     url: `/login/cellphone?phone=${data.phone}&password=${data.password}`,
   })
 }
 //获取用户详情
 export  function getuserInfo(uid){
  return instance({
     method: 'get',
     url: `/user/detail?uid=${uid}`,
   })
 }
 //喜欢音乐列表----(跨域)
 export  function getLike(uid){
  return instance({
     method: 'get',
     url: `/likelist?uid=${uid}`,
     headers:{
      "Authorization":localStorage.getItem('token')
    }
   })
 }
